var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.previewVisible,"destroyOnClose":true,"title":"文件预览","width":860,"footer":null},on:{"cancel":function($event){_vm.previewVisible = false}}},[_c('iframe',{attrs:{"src":_vm.kkPreviewDocUrl,"frameborder":"0","width":"800","height":"600"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }